const mutations = {
  'SET_PACKAGE' (state, value) {
    state.selectedPackage = value
  }
}

export default mutations
